import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { environment } from '../../environments/environment';
import { AuthGaurdService } from './auth-gaurd.service';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { QuickLinksModel } from '../models/home/quicklinks.model';

@Injectable({
    providedIn: 'root'
})
export class QuickLinksService {

    opts = [];

    private host = environment.apiUrl + "quicklinks";
    public loggedinUser: string = '';

    constructor(private http: HttpClient,
        private logger: LoggerService, private authGaurdService: AuthGaurdService) {
        this.loggedinUser = this.authGaurdService.loginUser();
    }

    public saveQuickLink(quickLinksModel: QuickLinksModel): Observable<QuickLinksModel> {
        return this.http.post<QuickLinksModel>(`${this.host}/savequicklink`, quickLinksModel);
    }

    getQuickLinkNames() {
        this.opts = [];
        let url = this.host + '/getquicklinknames';
        return this.opts.length ?
            of(this.opts) :
            this.http.get<any>(url).pipe(tap(data => this.opts = data))
    }

    getQuickLinksList() {
        this.opts = [];
        let url = this.host + '/getquicklinkslist';
        return this.opts.length ?
            of(this.opts) :
            this.http.get<QuickLinksModel[]>(url).pipe(tap(data => this.opts = data))
    }

}


